import React from 'react';

const ConsultancyLogo = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1005.174 175.07">
			<g id="Logos" transform="translate(0.004)">
				<path
					id="Path_1"
					data-name="Path 1"
					d="M67.76,31.35A38.216,38.216,0,0,1,91.85,90.26l15.59,15.61A60.223,60.223,0,0,0,67.74,8.92l.02,22.43Z"
					fill="#239037"
				/>
				<path
					id="Path_2"
					data-name="Path 2"
					d="M81.16,100.74a38.167,38.167,0,1,1-28.4-69.43V8.94A60.168,60.168,0,1,0,96.75,116.42l-15.6-15.68Z"
					fill="#21244a"
				/>
				<rect
					id="Rectangle_1"
					data-name="Rectangle 1"
					width="0.87"
					height="173.22"
					transform="translate(153.81)"
					fill="#212449"
				/>
				<path
					id="Path_3"
					data-name="Path 3"
					d="M6.37,148.02h-6v-3.87H16.82v3.87h-6v16.72H6.4Z"
					fill="#212449"
				/>
				<path
					id="Path_4"
					data-name="Path 4"
					d="M26.18,157.39H22.97v7.35h-4.4V144.15h9.65c4.3,0,6.93,2.82,6.93,6.65a5.913,5.913,0,0,1-4.51,6.12l4.63,7.86h-5Zm1.39-9.47h-4.6v5.69h4.6a2.86,2.86,0,0,0,.59-5.69A2.907,2.907,0,0,0,27.57,147.92Z"
					fill="#212449"
				/>
				<path
					id="Path_5"
					data-name="Path 5"
					d="M51.54,161.22H42.33l-1.3,3.56H36.2l8-20.63h5.51l7.93,20.59h-4.8l-1.3-3.52Zm-8-3.8h6.84l-3.4-9.46Z"
					fill="#212449"
				/>
				<path
					id="Path_6"
					data-name="Path 6"
					d="M57.08,154.48a10.442,10.442,0,0,1,10.2-10.67h.63a9.5,9.5,0,0,1,8.78,5l-3.77,1.93a5.658,5.658,0,0,0-5-3c-3.59,0-6.31,2.87-6.31,6.77s2.72,6.77,6.31,6.77a5.578,5.578,0,0,0,5-3l3.77,1.83a9.559,9.559,0,0,1-8.78,5.07,10.446,10.446,0,0,1-10.83-10.04v-.66Z"
					fill="#212449"
				/>
				<path
					id="Path_7"
					data-name="Path 7"
					d="M79.75,158.53a9.019,9.019,0,0,0,6.56,2.79c2.41,0,3.59-1.15,3.59-2.32,0-1.55-1.8-2.08-4.18-2.63-3.37-.78-7.7-1.7-7.7-6.31,0-3.43,3-6.22,7.83-6.22a11.465,11.465,0,0,1,8,2.88l-2.41,3.21a8.842,8.842,0,0,0-5.9-2.25c-2,0-3,.86-3,2.1,0,1.39,1.74,1.82,4.12,2.38,3.4.77,7.73,1.8,7.73,6.37,0,3.78-2.69,6.62-8.26,6.62a11.891,11.891,0,0,1-8.75-3.28Z"
					fill="#212449"
				/>
				<path
					id="Path_8"
					data-name="Path 8"
					d="M96.88,144.15h4.39v20.59H96.88Z"
					fill="#212449"
				/>
				<path
					id="Path_9"
					data-name="Path 9"
					d="M105.82,158.53a9.014,9.014,0,0,0,6.55,2.79c2.42,0,3.59-1.15,3.59-2.32,0-1.55-1.79-2.08-4.17-2.63-3.37-.78-7.7-1.7-7.7-6.31,0-3.43,3-6.22,7.82-6.22a11.465,11.465,0,0,1,8,2.88l-2.44,3.21a8.818,8.818,0,0,0-5.91-2.25c-2,0-3,.86-3,2.1,0,1.39,1.73,1.82,4.11,2.38,3.41.77,7.74,1.8,7.74,6.37,0,3.78-2.7,6.62-8.26,6.62a11.9,11.9,0,0,1-8.76-3.28l2.43-3.34Z"
					fill="#212449"
				/>
				<path
					id="Path_10"
					data-name="Path 10"
					d="M185.38,59.14c0-24.6,18.6-41.4,42.6-41.4,17.64,0,27.84,9.6,33.48,19.56l-14.64,7.2a21.68,21.68,0,0,0-18.84-11.64c-14.52,0-25.08,11.16-25.08,26.28s10.56,26.27,25.08,26.27a21.452,21.452,0,0,0,18.84-11.67l14.62,7.11c-5.76,10-15.84,19.68-33.48,19.68-23.98,0-42.58-16.79-42.58-41.39Z"
					fill="#212449"
				/>
				<path
					id="Path_11"
					data-name="Path 11"
					d="M262.62,59.14c0-24.12,17.64-41.4,41.76-41.4s41.88,17.28,41.88,41.4-17.64,41.39-41.88,41.39S262.62,83.25,262.62,59.14Zm66.12,0c0-15-9.6-26.28-24.36-26.28s-24.24,11.28-24.24,26.28,9.48,26.27,24.24,26.27,24.36-11.4,24.36-26.27Z"
					fill="#212449"
				/>
				<path
					id="Path_12"
					data-name="Path 12"
					d="M410.2,99.09,372.04,46.9V99.09h-17v-80h17.52l37.08,50.28V19.06h17v80Z"
					fill="#212449"
				/>
				<path
					id="Path_13"
					data-name="Path 13"
					d="M434.06,87.81l9.24-13a35.06,35.06,0,0,0,25.43,10.8c9.36,0,13.92-4.31,13.92-8.88,0-14.15-46.07-4.43-46.07-34.55,0-13.32,11.52-24.36,30.35-24.36,12.72,0,23.28,3.84,31.2,11.16l-9.48,12.48a34.36,34.36,0,0,0-23.28-8.72c-7.32,0-11.4,3.24-11.4,8,0,12.72,46,4.2,46,34.07,0,14.64-10.44,25.68-32,25.68C452.53,100.53,441.5,95.37,434.06,87.81Z"
					fill="#212449"
				/>
				<path
					id="Path_14"
					data-name="Path 14"
					d="M507.54,67.17V19.06h17.28V66.58c0,11.15,6.48,18.83,18.84,18.83s18.72-7.68,18.72-18.83V19.06h17.4v48c0,19.91-11.76,33.47-36.12,33.47s-36.12-13.68-36.12-33.36Z"
					fill="#212449"
				/>
				<path
					id="Path_15"
					data-name="Path 15"
					d="M592.44,99.09v-80h17v65h33.84v15Z"
					fill="#212449"
				/>
				<path
					id="Path_16"
					data-name="Path 16"
					d="M657.59,99.09v-65h-23.4v-15h63.83v15H674.75v65Z"
					fill="#212449"
				/>
				<path
					id="Path_17"
					data-name="Path 17"
					d="M750.88,99.09l-4.92-13.56H711.64l-5,13.56H687.17l30.95-80h21.32l30.84,80h-19.4Zm-22.08-63L716.32,70.54h25L728.8,36.09Z"
					fill="#212449"
				/>
				<path
					id="Path_18"
					data-name="Path 18"
					d="M829.61,99.09,791.44,46.9V99.09h-17v-80h17.5l37.07,50.28V19.06h17v80Z"
					fill="#212449"
				/>
				<path
					id="Path_19"
					data-name="Path 19"
					d="M854.73,59.14c0-24.6,18.6-41.4,42.6-41.4,17.64,0,27.84,9.6,33.48,19.56l-14.64,7.2a21.68,21.68,0,0,0-18.84-11.64c-14.52,0-25.08,11.16-25.08,26.28s10.56,26.27,25.08,26.27a21.452,21.452,0,0,0,18.84-11.67l14.64,7.07c-5.76,10-15.84,19.68-33.48,19.68-24,.04-42.6-16.75-42.6-41.35Z"
					fill="#212449"
				/>
				<path
					id="Path_20"
					data-name="Path 20"
					d="M957.53,99.09V66.34L926.7,19.06h19.43l19.92,32.16,19.68-32.16h19.44l-30.6,47.28V99.09Z"
					fill="#212449"
				/>
				<path
					id="Path_21"
					data-name="Path 21"
					d="M191,164.85V130.07h6.09v34.78Z"
					fill="#229137"
				/>
				<path
					id="Path_22"
					data-name="Path 22"
					d="M220.26,164.85V149.1c0-3.91-2-5.21-5.05-5.21a8.259,8.259,0,0,0-6.45,3.39v17.57h-5.47V139.66h5.47v3.44a11.876,11.876,0,0,1,8.85-4.06c5.41,0,8.12,2.92,8.12,8.08v17.73Z"
					fill="#229137"
				/>
				<path
					id="Path_23"
					data-name="Path 23"
					d="M229.44,161.56l2.49-4a13.019,13.019,0,0,0,8.54,3.55c3.28,0,4.95-1.41,4.95-3.39,0-5-15.2-1.41-15.2-11.06,0-4.12,3.54-7.66,9.89-7.66a14.414,14.414,0,0,1,9.79,3.54l-2.29,3.86a10.136,10.136,0,0,0-7.45-3c-2.86,0-4.68,1.3-4.68,3.07,0,4.49,15.2,1.15,15.2,11.16,0,4.43-3.7,7.82-10.47,7.82a15.242,15.242,0,0,1-10.77-3.89Z"
					fill="#229137"
				/>
				<path
					id="Path_24"
					data-name="Path 24"
					d="M254.21,133.2a3.39,3.39,0,1,1,3.39,3.39A3.419,3.419,0,0,1,254.21,133.2Zm.68,31.65V139.66h5.47v25.19h-5.47Z"
					fill="#229137"
				/>
				<path
					id="Path_25"
					data-name="Path 25"
					d="M265.81,171.31l2.55-4c2,2.35,4.64,3.23,8,3.23,3.59,0,7.45-1.67,7.45-6.83v-3a10.2,10.2,0,0,1-8.07,4.17c-6.41,0-11.15-4.64-11.15-12.93s4.69-12.93,11.15-12.93a10,10,0,0,1,8.07,4.12v-3.5h5.46v23.9c0,9.08-6.71,11.53-12.91,11.53-4.3,0-7.47-.94-10.55-3.76Zm18-14.65v-9.38a8.162,8.162,0,0,0-6.46-3.39c-4.32,0-7.08,3.23-7.08,8.08s2.76,8.08,7.08,8.08a8.162,8.162,0,0,0,6.43-3.39Z"
					fill="#229137"
				/>
				<path
					id="Path_26"
					data-name="Path 26"
					d="M312.03,164.85V149c0-3.91-2-5.11-5.1-5.11a8.424,8.424,0,0,0-6.45,3.39v17.57h-5.47V130.07h5.43v13a12,12,0,0,1,8.9-4.06c5.41,0,8.12,2.81,8.12,8v17.84h-5.43Z"
					fill="#229137"
				/>
				<path
					id="Path_27"
					data-name="Path 27"
					d="M324.44,159.01V144.46h-4.17v-4.8h4.17v-6.92h5.46v6.88H335v4.8h-5.1v13.19c0,1.72.83,3,2.4,3a3.47,3.47,0,0,0,2.44-.88l1.31,4.12a7.283,7.283,0,0,1-5.16,1.61c-4.18,0-6.45-2.28-6.45-6.45Z"
					fill="#229137"
				/>
				<path
					id="Path_28"
					data-name="Path 28"
					d="M337.58,161.56l2.5-4a13.019,13.019,0,0,0,8.54,3.55c3.28,0,4.94-1.41,4.94-3.39,0-5-15.2-1.41-15.2-11.06,0-4.12,3.54-7.66,9.89-7.66a14.414,14.414,0,0,1,9.79,3.54l-2.29,3.86a10.136,10.136,0,0,0-7.45-3c-2.86,0-4.68,1.3-4.68,3.07,0,4.49,15.2,1.15,15.2,11.16,0,4.43-3.7,7.82-10.46,7.82a15.266,15.266,0,0,1-10.78-3.89Z"
					fill="#229137"
				/>
				<path
					id="Path_29"
					data-name="Path 29"
					d="M392.03,164.85v-2.71a10.625,10.625,0,0,1-8.12,3.33c-4.11,0-8.75-2.76-8.75-8.34s4.64-8.19,8.75-8.19c3.39,0,6.3,1.1,8.12,3.24v-3.76c0-2.92-2.39-4.69-5.88-4.69a10.3,10.3,0,0,0-7.44,3.18l-2.27-3.81a14.905,14.905,0,0,1,10.57-4.06c5.57,0,10.46,2.34,10.46,9.12v16.69Zm0-5.74v-3.8a7.342,7.342,0,0,0-6-2.61c-3.08,0-5.37,1.77-5.37,4.53s2.29,4.49,5.37,4.49A7.342,7.342,0,0,0,392.03,159.11Z"
					fill="#229137"
				/>
				<path
					id="Path_30"
					data-name="Path 30"
					d="M420.2,164.85V149.1c0-3.91-2-5.21-5-5.21a8.278,8.278,0,0,0-6.46,3.39v17.57h-5.46V139.66h5.46v3.44a11.928,11.928,0,0,1,8.85-4.06c5.42,0,8.12,2.92,8.12,8.08v17.73Z"
					fill="#229137"
				/>
				<path
					id="Path_31"
					data-name="Path 31"
					d="M449.26,164.85v-3.44a10.169,10.169,0,0,1-8.07,4.06c-6.46,0-11.2-4.9-11.2-13.19s4.69-13.24,11.2-13.24a10.1,10.1,0,0,1,8.07,4.12V130.07h5.46v34.78h-5.46Zm0-7.56v-10a8.242,8.242,0,0,0-6.51-3.39c-4.32,0-7.08,3.49-7.08,8.39s2.76,8.34,7.08,8.34A8.251,8.251,0,0,0,449.26,157.29Z"
					fill="#229137"
				/>
				<path
					id="Path_32"
					data-name="Path 32"
					d="M474.3,164.85V130.07h17.07c6.36,0,9.9,4,9.9,8.86a7.817,7.817,0,0,1-6,8c3.69.57,6.71,4.28,6.71,8.55,0,5.37-3.59,9.39-10.1,9.39Zm20.72-24.87c0-2.61-1.77-4.54-4.9-4.54h-9.68v9h9.73c3.08.02,4.85-1.86,4.85-4.46h0Zm.68,14.65c0-2.61-1.83-4.8-5.31-4.8h-9.95v9.65h10c3.28,0,5.26-1.83,5.26-4.85h0Z"
					fill="#229137"
				/>
				<path
					id="Path_33"
					data-name="Path 33"
					d="M505.29,152.23c0-7.3,5.32-13.19,12.76-13.19s12.39,5.79,12.39,13.7v1.3H511.02a7.628,7.628,0,0,0,8,6.94,10.613,10.613,0,0,0,7.13-2.76l2.5,3.59a14.639,14.639,0,0,1-10.2,3.65C510.92,165.46,505.29,160.21,505.29,152.23Zm12.76-8.71c-4.69,0-6.82,3.6-7.08,6.68h14.16a6.726,6.726,0,0,0-6.77-6.69h-.31Z"
					fill="#229137"
				/>
				<path
					id="Path_34"
					data-name="Path 34"
					d="M532.44,161.56l2.5-4a12.994,12.994,0,0,0,8.53,3.55c3.28,0,4.95-1.41,4.95-3.39,0-5-15.2-1.41-15.2-11.06,0-4.12,3.54-7.66,9.89-7.66a14.413,14.413,0,0,1,9.79,3.54l-2.29,3.86a10.136,10.136,0,0,0-7.45-3c-2.86,0-4.68,1.3-4.68,3.07,0,4.49,15.2,1.15,15.2,11.16,0,4.43-3.7,7.82-10.47,7.82a15.242,15.242,0,0,1-10.77-3.89Z"
					fill="#229137"
				/>
				<path
					id="Path_35"
					data-name="Path 35"
					d="M563.33,161.35v13.09h-5.46V139.66h5.46v3.44a10,10,0,0,1,8.11-4.06c6.51,0,11.14,4.9,11.14,13.19s-4.63,13.24-11.14,13.24a9.871,9.871,0,0,1-8.11-4.12Zm13.54-9.12c0-4.85-2.76-8.34-7.08-8.34a8.162,8.162,0,0,0-6.46,3.39v10a8.293,8.293,0,0,0,6.46,3.39C574.11,160.62,576.87,157.13,576.87,152.23Z"
					fill="#229137"
				/>
				<path
					id="Path_36"
					data-name="Path 36"
					d="M585.44,152.23c0-7.2,5-13.19,12.91-13.19s13,6,13,13.19-4.9,13.24-13,13.24S585.44,159.48,585.44,152.23Zm20.2,0c0-4.43-2.6-8.34-7.29-8.34s-7.23,3.91-7.23,8.34,2.6,8.39,7.23,8.39,7.31-3.88,7.31-8.39Z"
					fill="#229137"
				/>
				<path
					id="Path_37"
					data-name="Path 37"
					d="M632.33,164.85l-7.71-10.38-3.49,3.6v6.78h-5.46V130.07h5.46v21.74l11.09-12.15h6.77l-10.46,11.42,10.67,13.77h-6.87Z"
					fill="#229137"
				/>
				<path
					id="Path_38"
					data-name="Path 38"
					d="M639.13,152.23c0-7.3,5.31-13.19,12.76-13.19s12.39,5.79,12.39,13.71v1.3H644.86a7.622,7.622,0,0,0,8,6.94,10.613,10.613,0,0,0,7.13-2.76l2.5,3.59a14.663,14.663,0,0,1-10.21,3.65C644.75,165.47,639.13,160.21,639.13,152.23Zm12.76-8.71c-4.69,0-6.82,3.6-7.08,6.68h14.16a6.743,6.743,0,0,0-6.79-6.69h-.29Z"
					fill="#229137"
				/>
				<path
					id="Path_39"
					data-name="Path 39"
					d="M682.18,164.85V130.07H695.1c10.83,0,18.17,7.19,18.17,17.41s-7.34,17.37-18.17,17.37Zm24.84-17.37c0-6.72-4.17-12-11.92-12h-6.82v24h6.82C702.65,159.48,707.02,154.05,707.02,147.48Z"
					fill="#229137"
				/>
				<path
					id="Path_40"
					data-name="Path 40"
					d="M716.38,152.23c0-7.3,5.31-13.19,12.76-13.19s12.39,5.79,12.39,13.71v1.3H722.11a7.628,7.628,0,0,0,8,6.94,10.613,10.613,0,0,0,7.13-2.76l2.5,3.59a14.639,14.639,0,0,1-10.2,3.65c-7.53,0-13.16-5.26-13.16-13.24Zm12.76-8.71c-4.69,0-6.82,3.6-7.08,6.68h14.16a6.726,6.726,0,0,0-6.77-6.69h-.31Z"
					fill="#229137"
				/>
				<path
					id="Path_41"
					data-name="Path 41"
					d="M751.72,164.85l-10.28-25.19h5.83l7.34,18.88,7.34-18.88h5.89l-10.26,25.19h-5.86Z"
					fill="#229137"
				/>
				<path
					id="Path_42"
					data-name="Path 42"
					d="M767.83,152.23c0-7.3,5.31-13.19,12.76-13.19s12.39,5.79,12.39,13.71v1.3H773.56a7.628,7.628,0,0,0,8,6.94,10.613,10.613,0,0,0,7.13-2.76l2.5,3.59a14.639,14.639,0,0,1-10.2,3.65c-7.55,0-13.16-5.26-13.16-13.24Zm12.76-8.71c-4.69,0-6.82,3.6-7.08,6.68h14.16a6.726,6.726,0,0,0-6.77-6.69h-.31Z"
					fill="#229137"
				/>
				<path
					id="Path_43"
					data-name="Path 43"
					d="M797.23,164.85V130.07h5.47v34.78Z"
					fill="#229137"
				/>
				<path
					id="Path_44"
					data-name="Path 44"
					d="M807.03,152.23c0-7.2,4.95-13.19,12.91-13.19s13,6,13,13.19-4.9,13.24-13,13.24S807.03,159.48,807.03,152.23Zm20.2,0c0-4.43-2.6-8.34-7.29-8.34s-7.23,3.91-7.23,8.34,2.6,8.39,7.23,8.39,7.29-3.88,7.29-8.39Z"
					fill="#229137"
				/>
				<path
					id="Path_45"
					data-name="Path 45"
					d="M842.7,161.35v13.09h-5.46V139.66h5.46v3.44a10,10,0,0,1,8.07-4.06c6.51,0,11.14,4.9,11.14,13.19s-4.63,13.24-11.14,13.24a9.878,9.878,0,0,1-8.07-4.12Zm13.54-9.12c0-4.85-2.76-8.34-7.08-8.34a8.162,8.162,0,0,0-6.46,3.39v10a8.293,8.293,0,0,0,6.46,3.39C853.44,160.62,856.24,157.13,856.24,152.23Z"
					fill="#229137"
				/>
				<path
					id="Path_46"
					data-name="Path 46"
					d="M897.18,164.85V148.42c0-2.71-1.2-4.53-4.11-4.53a7.634,7.634,0,0,0-5.83,3.33v17.63h-5.47V148.42c0-2.71-1.2-4.53-4.17-4.53a7.611,7.611,0,0,0-5.77,3.39v17.57h-5.47V139.66h5.47v3.44a10.859,10.859,0,0,1,8.17-4.06c3.75,0,6,1.88,6.87,4.64a10.639,10.639,0,0,1,8.54-4.64c4.63,0,7.24,2.5,7.24,7.61v18.2Z"
					fill="#229137"
				/>
				<path
					id="Path_47"
					data-name="Path 47"
					d="M906.93,152.23c0-7.3,5.31-13.19,12.76-13.19s12.39,5.79,12.39,13.71v1.3H912.66a7.628,7.628,0,0,0,8,6.94,10.613,10.613,0,0,0,7.13-2.76l2.5,3.59a14.639,14.639,0,0,1-10.2,3.65c-7.53,0-13.16-5.26-13.16-13.24Zm12.76-8.71c-4.69,0-6.82,3.6-7.08,6.68h14.16a6.726,6.726,0,0,0-6.77-6.69h-.31Z"
					fill="#229137"
				/>
				<path
					id="Path_48"
					data-name="Path 48"
					d="M953.24,164.85V149.1c0-3.91-2-5.21-5-5.21a8.278,8.278,0,0,0-6.46,3.39v17.57h-5.46V139.66h5.46v3.44a11.928,11.928,0,0,1,8.85-4.06c5.42,0,8.12,2.92,8.12,8.08v17.73h-5.51Z"
					fill="#229137"
				/>
				<path
					id="Path_49"
					data-name="Path 49"
					d="M965.65,159.01V144.46h-4.16v-4.8h4.16v-6.92h5.47v6.88h5.1v4.8h-5.1v13.19c0,1.72.83,3,2.39,3a3.494,3.494,0,0,0,2.45-.88l1.3,4.12a7.255,7.255,0,0,1-5.15,1.61c-4.22,0-6.46-2.28-6.46-6.45Z"
					fill="#229137"
				/>
			</g>
		</svg>
	);
};

export default ConsultancyLogo;
